import { render, staticRenderFns } from "./Noticewrite.vue?vue&type=template&id=4addf08b&"
import script from "./Noticewrite.vue?vue&type=script&lang=js&"
export * from "./Noticewrite.vue?vue&type=script&lang=js&"
import style0 from "./Noticewrite.vue?vue&type=style&index=0&id=4addf08b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports